<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    width="500px"
    @close="handleClose"
    :close-on-click-modal="false"
  >
    <el-form 
      ref="form" 
      :model="form" 
      :rules="rules" 
      label-width="100px"
      size="small"
    >
      <el-form-item label="状态：" prop="status" v-if="isEdit">
        <el-select
          v-model="form.status"
          placeholder="请选择状态"
          style="width: 100%"
          :disabled="!isEdit"
        >
          <el-option 
            v-for="option in statusOptions" 
            :key="option.value" 
            :label="option.label" 
            :value="option.value"
          />
        </el-select>
      </el-form-item>
      
      <el-form-item label="联系人：" prop="contactName">
        <el-input
          v-model="form.contactName"
          placeholder="请输入联系人姓名"
          clearable
          maxlength="20"
          show-word-limit
        />
      </el-form-item>
      
      <el-form-item label="联系电话：" prop="contactPhone">
        <el-input
          v-model="form.contactPhone"
          placeholder="请输入联系电话"
          clearable
          maxlength="11"
        />
      </el-form-item>
      
      <el-form-item label="位置：" prop="location">
        <el-input
          v-model="form.location"
          placeholder="请输入具体位置（如：A栋301室）"
          clearable
          maxlength="50"
          show-word-limit
        />
      </el-form-item>
      
      <el-form-item label="问题描述：" prop="description">
        <el-input
          v-model="form.description"
          type="textarea"
          :rows="4"
          placeholder="请详细描述需要维修的问题"
          clearable
          maxlength="500"
          show-word-limit
        />
      </el-form-item>
    </el-form>
    
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose" size="small">取消</el-button>
      <el-button 
        type="primary" 
        @click="handleSubmit" 
        size="small"
        :loading="loading"
      >
        确定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "PropertyRepairDialog",
  
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: () => ({})
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  
  data() {
    return {
      form: {
        id: '',
        contactName: '',
        contactPhone: '',
        location: '',
        description: '',
        status: 1
      },
      
      // 状态选项 - 确保 value 是数字类型
      statusOptions: [
        { label: '待处理', value: 1 },
        { label: '派单中', value: 2 },
        { label: '维修中', value: 3 },
        { label: '已完成', value: 4 },
        { label: '已取消', value: 5 }
      ],
      
      rules: {
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ],
        contactName: [
          { required: true, message: '请输入联系人姓名', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        contactPhone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        location: [
          { required: true, message: '请输入具体位置', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        description: [
          { required: true, message: '请输入问题描述', trigger: 'blur' },
          { min: 5, max: 500, message: '长度在 5 到 500 个字符', trigger: 'blur' }
        ]
      },
      loading: false
    }
  },
  
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      }
    },
    
    dialogTitle() {
      return this.isEdit ? '编辑维修信息' : '新建维修申请';
    },
    
    // 计算当前状态的显示标签
    currentStatusLabel() {
      const option = this.statusOptions.find(opt => opt.value === this.form.status);
      return option ? option.label : '未知状态';
    }
  },
  
  watch: {
    visible(newVal) {
      if (newVal) {
        this.resetForm();
        if (this.formData && Object.keys(this.formData).length > 0) {
          // 确保状态值是数字类型
          const statusValue = Number(this.formData.status);
          
          this.form = {
            id: this.formData.id || '',
            contactName: this.formData.contactName || '',
            contactPhone: this.formData.contactPhone || '',
            location: this.formData.location || '',
            description: this.formData.description || '',
            status: isNaN(statusValue) ? 1 : statusValue // 确保是数字
          };
        }
        
        // 新增时默认为待处理状态
        if (!this.isEdit) {
          this.form.status = 1;
        }
        
        // 使用 $nextTick 确保 DOM 更新后操作
        this.$nextTick(() => {
          if (this.$refs.form) {
            this.$refs.form.clearValidate();
          }
          
          // 调试信息 - 查看当前表单状态值
          console.log('当前表单状态值:', this.form.status, '类型:', typeof this.form.status);
        });
      }
    }
  },
  
  methods: {
    resetForm() {
      this.form = {
        id: '',
        contactName: '',
        contactPhone: '',
        location: '',
        description: '',
        status: 1
      };
    },
    
    handleClose() {
      this.dialogVisible = false;
      this.$emit('close');
      this.resetForm();
    },
    
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          
          // 确保状态是数字类型
          const submitData = {
            ...this.form,
            status: Number(this.form.status)
          };
          
          console.log('提交的数据:', submitData);
          
          // 发送保存事件
          this.$emit('save', submitData);
          
          // 模拟异步操作
          setTimeout(() => {
            this.loading = false;
            this.handleClose();
          }, 500);
        } else {
          this.$message.warning('请正确填写表单');
          return false;
        }
      });
    },
    
    // 添加一个方法获取状态标签（用于调试）
    getStatusLabel(value) {
      const option = this.statusOptions.find(opt => opt.value === value);
      return option ? option.label : `未知(${value})`;
    }
  }
}
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}

.el-form-item {
  margin-bottom: 18px;
}

.el-input,
.el-select,
.el-textarea {
  width: 100%;
}
</style>